// React
import React, { Component } from "react";
import { Link } from 'react-router-dom';

// Libraries
import { configureAnchors, goToTop } from 'react-scrollable-anchor';
import ResizeAware from 'react-resize-aware';

// Components
import { Footer } from '../../Components';
import { LoginPanel, HowItWorks, Features, Team, Exchanges } from './';

// Utils
import { GoogleAnalytics } from '../../Utils';

// Styles
import './sections.css';

/**********************************************************
 *    Login Component
 * 
 *  - Responsible for entire login page
 *  - Parent to LoginPanel
 * 
 **********************************************************/

class Login extends Component {

    /**********************************************************
     *  Constructor
     **********************************************************/

    constructor(props) {

        super(props);

        this.state = {
            loggedIn: true,
            panelTitle: 'Login',
            menuClass: 'hamburger hamburger--3dx',
            menuOpen: false,
            screenWidth: 1000
        }
    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    componentWillMount() {

        configureAnchors({
            scrollDuration: 400,
            keepLastAnchorHash: false
        });

    }

    componentDidMount() {

        GoogleAnalytics.newPage('/');


    }


/**********************************************************
 *  Functions
 **********************************************************/

    // Returns to top of page
    backToTop() {

        goToTop();
        
    }

    // Opens the hamburger menu
    openMenu() {

        var newMenu = 'hamburger hamburger--3dx';

        if(this.state.menuClass === 'hamburger hamburger--3dx')
            newMenu += ' is-active';

        this.setState((prevState, props) => {
            return {
                menuClass: newMenu,
                menuOpen : !this.state.menuOpen
            }
        });

    }


    // Given a new screen size, assess if its worth changing and change it
    updateScreenSize = ({width, height}) => {

        //console.log('Login.updateScreenSize()');

        this.setState((prevState, props) => {
            return {
                screenWidth : width
            }
        });

    }


/**********************************************************
 *  Render
 **********************************************************/

    render() {

        // Standard Menu
        var menu = (
            <React.Fragment>
                <div className="nav navbar-nav navbar-left" id="login-navbar-left">
                    <li><Link to="/dashboard"  onClick={() => GoogleAnalytics.newAction('Login','Dashboard')}><i className="icon-grid5 position-left"></i><span>Dashboard</span></Link></li>
                </div>

                <ul className="nav navbar-nav navbar-right" id="login-navbar-right">

                    <li><Link to="/markets"  onClick={() => GoogleAnalytics.newAction('Login','Markets')}><i className="icon-statistics position-left"></i><span>Markets</span></Link></li>
                    <li><Link to="/charts"  onClick={() => GoogleAnalytics.newAction('Login','Charts')}><i className="icon-graph position-left"></i><span>Charts</span></Link></li>

                </ul>
            </React.Fragment>
        );

        // If mobile size, show hamburger menu
        if(this.state.screenWidth < 900) {
            menu = (
                <button className={this.state.menuClass + ' far-right'} type="button" onClick={this.openMenu.bind(this)}>
                    <span className="hamburger-box">
                        <span className="hamburger-inner"></span>
                    </span>
                </button>
            );
        }

        var mobileMenu = null;
        if(this.state.menuOpen) {
            mobileMenu = (
                <div className="row">
                    <div className="mobile-menu">
                        <Link to="/dashboard" className="login-navbar-button" onClick={() => GoogleAnalytics.newAction('Login','Dashboard')}><i className="icon-grid5 position-left"></i><span>Dashboard</span></Link>

                        <Link to="/markets" className="login-navbar-button" onClick={() => GoogleAnalytics.newAction('Login','Markets')}><i className="icon-statistics position-left"></i><span>Markets</span></Link>

                        <Link to="/charts" className="login-navbar-button" onClick={() => GoogleAnalytics.newAction('Login','Charts')}><i className="icon-graph position-left"></i><span>Charts</span></Link>
                    </div>
                </div>
            );
        }

        return (

            
            <div className="page-container">
                <ResizeAware style={{ position: 'relative' }} onResize={this.updateScreenSize} >
            
                <div className="loginContainer">

                    {/*-- First Row --*/}
                    <div className="row" id="row1">

                        {/*-- Logo Column --*/}
                        <div className="col-lg-6 col-lg-offset-0 col-md-6 col-md-offset-0 col-sm-5 col-sm-offset-0 col-xs-6 col-xs-offset-1 login-col logo-box">
                            <div className="logo-holder">
                                <img src="/assets/img/logo.svg" className="yety-logo" alt=""></img>
                                <div className="yety-text">yety</div>
                            </div>
                        </div>
                        {/*-- / Logo Column --*/}

                        {/*-- Navbar Column --*/}
                        <div className="col-lg-6 col-md-6 col-sm-7 col-xs-4 login-col">


                            <div className="navbar login-navbar">

                                {menu}
                                
                            </div>

                        </div>
                        {/*-- / Navbar Column --*/}

                    </div>
                    {/*-- / First Row --*/}

                    {mobileMenu}

                    {/*-- Second Row --*/}
                    <div className="row" style={{marginTop:'10px'}}>

                        {/*-- Tagline Column --*/}
                        <div className="col-lg-6 col-lg-offset-0 col-md-6 col-md-offset-0 col-sm-6 col-sm-offset-0 col-xs-10 col-xs-offset-1 login-col">

                            <div id="tagline">See more from the top.</div>
                            <div id="tagline2">The smartest trading analytics for all of your cryptocurrency holdings, in one place.</div>

                        </div>
                        {/*-- / Tagline Column --*/}

                        {/*-- Login Box Column --*/}
                        <div className="col-lg-6 col-lg-offset-0 col-md-6 col-md-offset-0 col-sm-6 col-sm-offset-0 col-xs-10 col-xs-offset-1 login-col">

                            <LoginPanel title={this.state.panelTitle} history={this.props.history} />

                        </div>
                        {/*-- / Login Box Column --*/}


                    </div>
                    {/*-- / Second Row --*/}
                    <Link to="/beta" onClick={() => GoogleAnalytics.newAction('Login','Beta')} className="beta-popup hover-cartoon">
                        <div>
                            Looking for details to the Open Beta ?
                        </div>
                    </Link>

                    <div className="links">
                        <div className="link-parent">
                            <a href="#how-it-works" className="read-more">How It Works<i className="caret"></i></a>
                        </div>
                        <div className="link-parent">
                            <a href="#features" className="read-more">Features<i className="caret"></i></a>
                        </div>
                    </div>

                </div>

                <div className="sections-parent">

                    <HowItWorks />

                    <Features />

                    <Exchanges />

                    <Team />

                </div>

                <Footer />

                </ResizeAware>

            </div>
        );
    }
}

export default Login;





// WEBPACK FOOTER //
// ./src/Views/Login/Login.js